import config from '@/server/config';
import request from '@/server/request';
import * as utils from '@/server/utils';

const authAuth = async () => {
	
	if (!utils.getIsWxClient()) return;

	const r: any = await request({
		url: `${config.WAPAPI}auth/checkBind?userType=3&wechatAccountType=1`
	});

	if (r.code === 1) {
		if (!r.obj) {
			let returnUrl = utils.getQueryString('returnUrl') || window.location.href;
			returnUrl = encodeURIComponent(encodeURIComponent(returnUrl));

			window.location.href = `${config.WAPAPI}login/wechat/auth?returnUrl=${returnUrl}&businessUrl=${returnUrl}&userType=3&wechatAccountType=1`;
		}
	}
	
}

export default authAuth;